import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_drive-care-studio/artifacts/fux2oafj_Screenshot%202026-09-19%20at%2012.43.19.webp";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("turbolux_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const mediaUrl = (url) =>
  !url ? "" : url.startsWith("http") ? url : `${BACKEND_URL}${url}`;

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  return e?.message || "Kļūda. Mēģini vēlreiz.";
}
